module.exports = __webpack_public_path__ + "static/img/t3.ba55e7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qtape/t3.png
// module id = wnGJ
// module chunks = 1